export const readCookie = (name: string): string | undefined => {
	const cookie = document.cookie.replace(/ /g, '').split(';').find((cookie) => {
		return cookie.startsWith(name);
	});

	return cookie?.split('=')[1];
};

export const setCookie = (name: string, value: string | boolean | number, expirationDate: Date = new Date(new Date().setMonth(new Date().getMonth() + 3))) => {
	document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}`;
};

export const removeCookie = (name: string) => {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
